import type { CropArea } from '../types/mockup'

/** Transparent product mockup: 6 volumes + tablet, laptop and phone. */
export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/mzDPUMdwXeWcbwRYYAGinZ/MockUp_(mari_ingles).png'

export const MOCKUP_WIDTH = 1536
export const MOCKUP_HEIGHT = 1024

export const STRESSED_INSTRUCTOR_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/d753879f-18ed-4954-a270-e5ae3e8c343a.jpg'

export const TEACHING_INSTRUCTOR_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/d2e60d2a-f837-488a-a9e6-77d6e76fef65.jpg'

/** Regions of the mockup reused across the page. */
export const volumesBand: CropArea = { x: 40, y: 82, w: 1480, h: 470 }
export const devicesArea: CropArea = { x: 100, y: 552, w: 1290, h: 430 }
